// import React, { useEffect, useState } from 'react'
// import './Finaldisplay.css'

// const VISUAL_HEIGHT = 600;

// const imgs = [

//     'https://asset.weavebliss.com/assets/guestbookhowitworks/example2.png',
//     'https://asset.weavebliss.com/assets/guestbookhowitworks/example1.png',
//     'https://asset.weavebliss.com/assets/guestbookhowitworks/example3.png',
// ]

// function Finaldisplay() {
//     return <div className='Gbfinaldisplay_root' style={{ display: 'flex', flexDirection: 'column', minHeight: 950, height: 950 }}>

//         <div
//             className={`GbWritemessages_imgroot`}
//             style={{ height: `${VISUAL_HEIGHT}px`, marginBottom: 80, display:'flex', flexDirection:'row', width:'100%' }}
//         >
//             {imgs.map((img, index) => {
//                 return <img
//                     className="Finaldisplay_img"
//                     src={img}
//                     key={'img' + index}
//                 />
//             })}

//         </div>

//         <div className='Gbdrawings_subtitle'>
//             Actual wall-art downloadable image that you could print and place at wall,
//             scan the qr code to access to the digital ones, where viewers can read the guestbook online.
//         </div>
//     </div>
// }

// export default Finaldisplay

import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import './Finaldisplay.css';

const VISUAL_HEIGHT = 600;
const SLIDE_DURATION_MS = 400; // Slide animation duration
const AUTOPLAY_INTERVAL_MS = 3000; // Auto-play interval
const SWIPE_THRESHOLD = 50; // Minimum distance (pixels) to register a swipe

const imgs = [
    'https://asset.weavebliss.com/assets/guestbookhowitworks/f1.png',
    'https://asset.weavebliss.com/assets/guestbookhowitworks/fff2.png',
    'https://asset.weavebliss.com/assets/guestbookhowitworks/ff3.png',
    'https://asset.weavebliss.com/assets/guestbookhowitworks/f4.png',
];


function Directdigitalbtn() {
    return <div className='Guestbookhowitworks_lookuproot' style={{marginBottom:50}}>
        <button
            className='Guestbookhowitworks_lookupbtn'
            onClick={() => { document.getElementById('iepreview_btninvisible').click() }}
        >
            Browse Digital Guestbook
            {/* <Link id="iepreview_btninvisible" to={'/guestbooklookup/weddingurlhandler/weddingmodpasscode'} target="_blank" /> */}
            <Link id="iepreview_btninvisible" to={'/guestbooklookup/alicebob/alicebobmodpasscode'} target="_blank" />
        </button>
    </div>

}


function Finaldisplay() {
    const totalSlides = imgs.length;
    const [activeIndex, setActiveIndex] = useState(1);
    const [transitionStyle, setTransitionStyle] = useState(`transform ${SLIDE_DURATION_MS}ms ease-in-out`);
    
    // State for tracking touch events
    const [touchStart, setTouchStart] = useState(0);
    const [touchEnd, setTouchEnd] = useState(0);

    // Array with duplicates for the infinite loop: [LAST, ...ORIGINAL..., FIRST]
    const infiniteImgs = [
        imgs[totalSlides - 1], 
        ...imgs,
        imgs[0]
    ];
    const trackWidth = infiniteImgs.length;

    // --- Helper function to move to the next/prev slide ---
    const handleNext = () => setActiveIndex(prev => prev + 1);
    const handlePrev = () => setActiveIndex(prev => prev - 1);

    // --- 1. Autoplay Logic ---
    useEffect(() => {
        const interval = setInterval(handleNext, AUTOPLAY_INTERVAL_MS);
        return () => clearInterval(interval);
    }, []);

    // --- 2. Infinite Loop Reset Logic (Same as before) ---
    useEffect(() => {
        if (activeIndex === 0 || activeIndex === totalSlides + 1) {
            const timeout = setTimeout(() => {
                setTransitionStyle('none');
                if (activeIndex === 0) {
                    setActiveIndex(totalSlides);
                } else if (activeIndex === totalSlides + 1) {
                    setActiveIndex(1);
                }
            }, SLIDE_DURATION_MS);
            return () => clearTimeout(timeout);
        } else {
            if (transitionStyle === 'none') {
                const reEnableTimeout = setTimeout(() => {
                    setTransitionStyle(`transform ${SLIDE_DURATION_MS}ms ease-in-out`);
                }, 50); 
                return () => clearTimeout(reEnableTimeout);
            }
        }
    }, [activeIndex, totalSlides, transitionStyle]);
    
    // --- 3. Touch/Swipe Handlers ---
    const onTouchStart = (e) => {
        // Record the initial X position of the touch
        setTouchStart(e.targetTouches[0].clientX);
    };

    const onTouchMove = (e) => {
        // Record the current X position as the finger moves
        setTouchEnd(e.targetTouches[0].clientX);
    };

    const onTouchEnd = () => {
        if (touchStart === 0 || touchEnd === 0) return;

        const distance = touchStart - touchEnd;
        const isSwipe = Math.abs(distance) > SWIPE_THRESHOLD;

        if (isSwipe) {
            // Swipe right (touchEnd is > touchStart) -> Go to previous slide
            if (distance < 0) {
                handlePrev();
            } 
            // Swipe left (touchStart is > touchEnd) -> Go to next slide
            else if (distance > 0) {
                handleNext();
            }
        }

        // Reset touch tracking states
        setTouchStart(0);
        setTouchEnd(0);
    };
    
    // --- Render ---
    return (
        <div className='Gbfinaldisplay_root' style={{ display: 'flex', flexDirection: 'column', minHeight: 950, height: 950 }}>
            {/* Carousel Container */}
            <div 
                className={`GbWritemessages_imgroot carousel-container`}
                style={{ height: `${VISUAL_HEIGHT}px` }}
                // Attach touch event listeners here
                onTouchStart={onTouchStart}
                onTouchMove={onTouchMove}
                onTouchEnd={onTouchEnd}
            >
                {/* Carousel Track/Images Wrapper */}
                <div 
                    className="carousel-track"
                    style={{
                        transform: `translateX(-${activeIndex * 100 / trackWidth}%)`,
                        width: `${trackWidth * 100}%`,
                        transition: transitionStyle 
                    }}
                >
                    {infiniteImgs.map((img, index) => (
                        <div 
                            className="carousel-slide"
                            key={'slide-' + index}
                            style={{ width: `${100 / trackWidth}%` }} 
                        >
                             <img
                                className="Finaldisplay_img"
                                src={img}
                                alt={`Guestbook Example ${index}`}
                            />
                        </div>
                    ))}
                </div>
            </div>
            
            <div className='Gbdrawings_subtitle' style={{ marginTop: 40, marginBottom:0 }}>
            Guest doodles combine to create a wall art display, with messages and photos accessible in a digital guestbook via QR code. The complete guestbook is also available for download.
            </div>

            <Directdigitalbtn />
        </div>
    );
}

export default Finaldisplay;